export default "__VITE_PUBLIC_ASSET__581d3c77__"